import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';

const Logo = ({ variant = 'default', size = 'medium' }) => {
  // Define sizes
  const sizes = {
    small: {
      logoSize: 28,
      fontSize: '1.25rem',
      spacing: 0.75
    },
    medium: {
      logoSize: 36,
      fontSize: '1.5rem',
      spacing: 1
    },
    large: {
      logoSize: 48,
      fontSize: '2rem',
      spacing: 1.5
    }
  };

  // Define variants
  const variants = {
    default: {
      textColor: '#1e293b'
    },
    light: {
      textColor: '#ffffff'
    },
    dark: {
      textColor: '#f8fafc'
    }
  };

  const currentSize = sizes[size] || sizes.medium;
  const currentVariant = variants[variant] || variants.default;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Avatar
        src="/images/logo.png"
        alt="TravelIT Logo"
        variant="square"
        sx={{
          width: currentSize.logoSize,
          height: currentSize.logoSize,
          mr: currentSize.spacing,
          bgcolor: 'transparent'
        }}
      />
      <Typography
        variant={size === 'small' ? 'h6' : size === 'large' ? 'h4' : 'h5'}
        component="div"
        sx={{
          fontWeight: 700,
          color: currentVariant.textColor,
          letterSpacing: '-0.5px'
        }}
      >
        TravelIT
      </Typography>
    </Box>
  );
};

export default Logo;